import { LmgService } from "../resource";

const TransModule = {
  namespaced: true,
  state: {
    datas: [],
    cancel: [],
    whts: [],
    data: {},
	isLoading:false,
  },
  mutations: {
	SET_CANCEL(state, payload) {
		state.cancel = payload;
	},
	SET_WHTS(state, payload) {
		state.whts = payload;
	},
    SET_DATAS(state, payload) {
      state.datas = payload;
    },
    SET_DATA(state, payload) {
      state.data = payload;
    },
  },
  actions: {
    createData({ commit, state }, payload) {
      return LmgService.TransactionCreate(payload);
    },
    cancelData({ commit, state }, payload) {
      return LmgService.TransactionCancel(payload);
    },
    async listData({ commit, state },payload) {
		state.isLoading = true
      try {
        const resp = await LmgService.TransactionList(payload);
		commit("SET_DATAS", resp.data.Data == null ? [] : resp.data.Data);
		state.isLoading = false
      } catch (err) {
        commit("SET_DATAS", []);
		state.isLoading = false
      }
    },

	async listWht({ commit, state },payload) {
		state.isLoading = true
        commit("SET_WHTS", []);
		try {
			const resp = await LmgService.WhtList(payload);
			commit("SET_WHTS", resp.data.Data == null ? [] : resp.data.Data);
		state.isLoading = false
		} catch (err) {
			console.log(err)
			state.isLoading = false
		}
    },

	async listCancel({ commit, state },payload) {
		state.isLoading = true
        commit("SET_CANCEL", []);
		try {
			const resp = await LmgService.TransactionCancelList(payload);
			commit("SET_CANCEL", resp.data.Data == null ? [] : resp.data.Data);
		state.isLoading = false
		} catch (err) {
			console.log(err)
			state.isLoading = false
		}
    },

	async listWhtDetail({ commit, state },payload) {
		state.isLoading = true
        commit("SET_DATAS", []);
		try {
			const resp = await LmgService.TransactionByListID(payload);
			commit("SET_DATAS", resp.data.Data == null ? [] : resp.data.Data);
		state.isLoading = false
		} catch (err) {
			console.log(err)
			state.isLoading = false
		}
    },

	clearTrans({ commit, state }, payload){
		commit("SET_DATAS", []);
	},

	createWht({ commit, state }, payload) {
		return LmgService.WhtCreate(payload);
	  },
	  clearWht({ commit, state }, payload) {
		commit("SET_WHTS", []);
	  },

	exportWht({ commit, state }, payload) {
		return LmgService.WhtExport(payload);
	  },

    // --------------- Report ----------------------
    
    ReportDiscount({ commit, state }, payload) {
      return LmgService.ReportDiscount(payload);
    },

	ReportTaxDiscount({ commit, state }, payload) {
		return LmgService.ReportTaxDiscount(payload);
	  },

    CalCommision({ commit, state }, payload) {
      return LmgService.TransactionCalCommision(payload);
    },
  },
  getters: {
    getData(state) {
      return state.datas;
    },
	getWht(state) {
		return state.whts;
	},
	getCancel(state) {
		return state.cancel;
	},
	isLoading(state){
		return state.isLoading;
	}
    
  }
};

export default TransModule;
